import { Permisos } from '@/shared/constants/permisos';
import type { TourDefinicion } from '@/features/guia-interactiva/types/guia-interactiva.types';

export const tourSeguridadAplicaciones: TourDefinicion = {
  codigo: 'seguridad-aplicaciones',
  titulo: 'Aplicaciones',
  descripcion: 'Aplicaciones que forman parte del portal.',
  ruta: '/admin/seguridad/aplicaciones',
  permisoMenu: Permisos.APLICACIONES_MENU,
  pasos: [
    {
      id: 'seguridad-aplicaciones:header',
      selector: '[data-testid="seguridad-aplicaciones.header"]',
      titulo: 'Aplicaciones',
      descripcion:
        'Cada aplicación es un subsistema del portal (p. ej. RECET, ENSUASS). Los permisos y menús se agrupan por aplicación.',
      side: 'bottom',
      align: 'start',
    },
    {
      id: 'seguridad-aplicaciones:boton-crear',
      selector: '[data-testid="seguridad-aplicaciones.boton-crear"]',
      titulo: 'Nueva aplicación',
      descripcion:
        'Registra una aplicación con su código único y nombre visible. Luego podrás asociarle permisos y roles.',
      permisoRequerido: Permisos.APLICACIONES_CREAR,
      side: 'left',
      align: 'center',
    },
    {
      id: 'seguridad-aplicaciones:tabla',
      selector: '[data-testid="seguridad-aplicaciones.tabla"]',
      titulo: 'Listado',
      descripcion: 'Edita o desactiva cada aplicación desde las acciones de la fila.',
      side: 'top',
      align: 'center',
    },
  ],
};
